/* eslint-disable no-unused-vars */
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { baseHref } from "service/api";

export type CancelOrderInput = {
  orderId: string;
};

export type CreateOrderInput = {
  symbol: string;
  side: string;
  quantity: number;
  limit: number;
};

export type Order = {
  id: number;
  orderId: string;
  symbol: string;
  side: string;
  status: string;
  quantity: number;
  limit: number;
  initiationTime: string;
};

type OrderBookItem = {
  quantity: number;
  price: number;
};

type OrderBookResponse = {
  symbol: string;
  asks: OrderBookItem[];
  bids: OrderBookItem[];
};

type OrdersResponse = {
  result: boolean;
  orders: Order[];
};

type CancelOrderResponse = {
  result: boolean;
  orderId: string;
};

type CreateOrderResponse = {
  result: boolean;
  orderId: string;
};

export const tradeApi = createApi({
  reducerPath: "tradeApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${baseHref}/trade`,
    credentials: "include",
  }),
  tagTypes: ["OrderBook"],
  endpoints: (builder) => ({
    orderBook: builder.query<OrderBookResponse, { symbol: string }>({
      query: ({ symbol }) => ({
        url: `order-book`,
        method: "POST",
        body: { symbol },
      }),
    }),
    openOrders: builder.query<OrdersResponse, { symbol: string }>({
      query: ({ symbol }) => ({
        url: `open-orders`,
        method: "POST",
        body: { symbol },
      }),
    }),
    closedOrders: builder.query<OrdersResponse, { symbol: string }>({
      query: ({ symbol }) => ({
        url: `closed-orders`,
        method: "POST",
        body: { symbol },
      }),
    }),
    cancelOrder: builder.mutation<CancelOrderResponse, CancelOrderInput>({
      query: ({ orderId }) => ({
        url: `cancel-order`,
        method: "POST",
        body: { orderId },
      }),
    }),
    createOrder: builder.mutation<CreateOrderResponse, CreateOrderInput>({
      query: ({ quantity, side, limit, symbol }) => ({
        url: `create-order`,
        method: "POST",
        body: { quantity, side, limit, symbol },
      }),
    }),
  }),
});
export const {
  useOrderBookQuery,
  useOpenOrdersQuery,
  useClosedOrdersQuery,
  useCancelOrderMutation,
  useCreateOrderMutation,
} = tradeApi;
